import { css } from '@emotion/core';

export const searchResultLinkCSS = ({ colors }) => css`
    display: flex;
    flex-direction: row;
    width: 100%;
    text-decoration: none;

    align-items: center;

    div {
        display: flex;
        flex-direction: row;
        width: 100%;
        gap: 0.75rem;
    }
    svg {
        justify-self: end;
        color: ${colors.neutral70};
    }
`;

export const searchResultLinkPlatformCategoryCSS = ({ colors, fontSizes }) =>
    css`
        font-size: ${fontSizes.medium};
        color: ${colors.orange};
    `;

export const searchResultLinkFamilyCategoryCSS = ({ colors, fontSizes }) =>
    css`
        font-size: ${fontSizes.medium};
        color: ${colors.orange};
    `;

export const searchResultLinkCustomerCategoryCSS = ({ colors, fontSizes }) =>
    css`
        font-size: ${fontSizes.medium};
        color: ${colors.blueLight};
    `;
